/* ================================
   ChooseMe – Hero Banner
================================ */

function initHeroImageZoom() {
  const heroes = document.querySelectorAll('[data-hero-zoom]');
  if (!heroes.length) return;

  heroes.forEach(hero => {
    // force browser to register initial state
    hero.offsetHeight;

    requestAnimationFrame(() => {
      hero.classList.add('is-loaded');
    });
  });
}

/* Make the hero image itself clickable (Clarity showed dead taps on it).
   Taps on the existing buttons/links still work as before. */
const CM_HERO_LINK = '/collections/bras';

function initHeroImageLink() {
  const heroes = document.querySelectorAll('[data-hero-zoom]');
  if (!heroes.length) return;

  heroes.forEach(hero => {
    if (hero.dataset.cmLinked) return;
    const media = hero.querySelector('.banner__media');
    if (!media) return;
    hero.dataset.cmLinked = '1';
    media.style.cursor = 'pointer';

    hero.addEventListener('click', e => {
      if (window.Shopify && window.Shopify.designMode) return;
      if (e.target.closest('a, button, input, select, textarea')) return;
      const r = media.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
      window.location.href = CM_HERO_LINK;
    });
  });
}

function initHero() {
  initHeroImageZoom();
  initHeroImageLink();
}

// Run on normal page load
document.addEventListener('DOMContentLoaded', initHero);

// Run again when Shopify sections reload (theme editor safety)
document.addEventListener('shopify:section:load', initHero);
